module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-input"
  }, _vm._l((_vm.code), function(digit, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.code[index]),
        expression: "code[index]"
      }],
      key: index,
      ref: "inputs",
      refInFor: true,
      attrs: {
        "type": "text",
        "maxlength": "1"
      },
      domProps: {
        "value": (_vm.code[index])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.code, index, $event.target.value)
        }, function($event) {
          return _vm.onInput(index)
        }],
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "backspace", undefined, $event.key, undefined)) { return null; }
          return _vm.onBackspace(index)
        }
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ebef27e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordRecovery/CodeInput.vue
// module id = 1682
// module chunks = 6